import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';

import { SideNavComponent } from './side-nav.component';

const components = [
  SideNavComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MatIconModule,
    MatSidenavModule,
  ],
  exports: components,
})
export class SideNavModule { }
